@let helpNeededLabel = 'Hulp nodig?';

<crnt-button
  class="d-none d-lg-inline"
  wlAutomationId="helpNeeded"
  variant="secondary"
  (click)="clicked.emit()"
  wlTrackLink
  [trackLinkInfo]="{
    rendering: { componentName: 'NavigationHelpNeededButtonComponent' },
    field: helpNeededLabel,
    eventType: 'button-click',
    type: 'button',
  }"
>
  {{ helpNeededLabel }}
  <crnt-icon slot="leading" icon="messages" />
</crnt-button>
<crnt-icon-button
  class="d-inline d-lg-none"
  wlAutomationId="helpNeeded"
  variant="secondary"
  (click)="clicked.emit()"
  wlTrackLink
  [trackLinkInfo]="{
    rendering: { componentName: 'NavigationHelpNeededButtonComponent' },
    field: helpNeededLabel,
    eventType: 'button-click',
    type: 'button',
  }"
>
  <crnt-visually-hidden>
    {{ helpNeededLabel }}
  </crnt-visually-hidden>
  <crnt-icon icon="messages" />
</crnt-icon-button>
